/** @format */
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { Attainment, CourseUnitAttainment } from 'common-typescript/types';

@Component({
    selector: 'sis-course-unit-attainment-details',
    templateUrl: './course-unit-attainment-details.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CourseUnitAttainmentDetailsComponent {
    @Input() attainment: CourseUnitAttainment;
    @Input() secondaryAttainments: Attainment[];
    @Input() expirationImminent: boolean;
}
